import styled from 'styled-components';
import play from 'assets/images/play.svg';
import { fonts } from 'styles';

export const Container = styled.section`
  width: 100%;
  display: none;
  @media screen and (max-width: 1024px) {
    display: block;
  }
`;

export const Album = styled.div`
  margin-bottom: 96px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const AlbumHeader = styled.header`
  display: flex;
  column-gap: 24px;
  margin-bottom: 40px;

  div.wrapper {
    flex: 1;
  }
`;

export const AlbumYear = styled.div`
  font-family: ${fonts.BentonSansMedium};
  font-size: 25px;
  line-height: 50px;
  color: #fff;
  text-align: center;
  background-color: #0861f5;
  width: 60px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    display: block;
    font-size: 12px;
    line-height: 24px;
  }
`;

export const AlbumArtist = styled.span`
  display: block;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin-bottom: 16px;
`;

export const AlbumTitle = styled.h2`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 20px;
  line-height: 22px;
  color: #fff;
  text-transform: uppercase;
`;

export const AlbumCover = styled.img`
  width: 100%;
  margin-bottom: 40px;
`;

export const AlbumDescription = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin-bottom: 40px;

  p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const PlayIcon = styled.img.attrs({ src: play })`
  transition: 300ms ease;
`;

export const PlayButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  column-gap: 16px;
  color: #fff;
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  text-align: left;

  &:hover {
    ${PlayIcon} {
      transform: scale(1.1);
    }
  }
`;
